import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./propertyAmenity.actions";
import * as selectors from "./propertyAmenity.selectors";
export var useGetByPropertyId = function (params) {
    var propertyId = params.propertyId, _a = params.shouldRefetch, shouldRefetch = _a === void 0 ? false : _a;
    var dispatch = useDispatch();
    var items = useSelector(function (state) {
        return selectors.getByPropertyId(state, propertyId);
    });
    var isFetching = useSelector(function (state) {
        return selectors.isFetchingByPropertyId(state, propertyId);
    });
    var fetchError = useSelector(function (state) {
        return selectors.fetchErrorByPropertyId(state, propertyId);
    });
    useEffect(function () {
        if (!propertyId)
            return;
        if (isFetching)
            return;
        if (!shouldRefetch && items !== undefined)
            return;
        dispatch(actions.getByPropertyIdStart({ propertyId: propertyId }));
    }, [propertyId]);
    var refetch = function () {
        if (!propertyId)
            return;
        dispatch(actions.getByPropertyIdStart({ propertyId: propertyId }));
    };
    return {
        items: items,
        isFetching: isFetching,
        fetchError: fetchError,
        refetch: refetch,
    };
};
